import { GeoListingsFilters } from '@aloft/toolkit-shared';

import { FieldErrors } from 'react-hook-form';

import { PairedSalesFormInput } from '../../types.ts';

const fieldNameToDisplay: Record<keyof GeoListingsFilters, string> = {
  propertyType: 'Property Type',
  propertySubType: 'Property Subtype',
  saleDate: 'Sale Date',
  salePrice: 'Sale Price',
  gla: 'GLA',
  lotSize: 'Lot Size',
  zipCode: 'Zip Code',
  yearBuilt: 'Year Built',
  bedrooms: 'Bedrooms',
  fullBaths: 'Baths: Full',
  threeQuarterBaths: 'Baths: 3/4',
  halfBaths: 'Baths: Half',
  totalBaths: 'Baths: Total',
  stories: 'Stories',
  garageSpaces: 'Garage Spaces',
  hasBasement: 'Has Basement',
  style: 'Design (Style)',
  view: 'View',
  attached: 'Attachment',
  hasPool: 'Has Pool',
  statuses: 'Status',
};

type FieldError = { message?: string | undefined };
const isFieldError = (x: unknown): x is FieldError =>
  typeof x === 'object' && x !== null && 'message' in x;

type RangeInputFieldError = { min?: FieldError; max?: FieldError };
const isRangeInputFieldError = (x: unknown): x is RangeInputFieldError =>
  typeof x === 'object' && x !== null && ('min' in x || 'max' in x);

const fallback = 'is invalid';

const getMessages = (value: FieldError | { min?: FieldError; max?: FieldError }): string[] => {
  if (isFieldError(value)) return [value.message ?? fallback];

  const msgs: string[] = [];

  if (value.min) msgs.push(`min ${value.min.message}`);
  if (value.max) msgs.push(`max ${value.max.message}`);

  return msgs;
};

export const getErrorMessages = (errors: FieldErrors<PairedSalesFormInput>): string[] => {
  const formattedMessages: string[] = [];
  if (!errors?.search?.filters) return formattedMessages;

  for (const [key, value] of Object.entries(errors.search.filters)) {
    const formattedKey = fieldNameToDisplay[key as keyof GeoListingsFilters] ?? key;

    if (isFieldError(value) || isRangeInputFieldError(value)) {
      for (const message of getMessages(value)) {
        formattedMessages.push(`${formattedKey} ${message}`);
      }
    }
  }

  return formattedMessages;
};
